export enum OpenForBidsSortBy {
    "NewestToOldest" = "Date Created - Newest to Oldest",
    "OldestToNewest" = "Date Created - Oldest to Newest"
}